import ApiBase from './ApiBase';
import axios from 'axios';

class DistributionListApi extends ApiBase {
  /**
   * Get fund/investor
   * @param payload
   */
  getEmailAddressesByFilter = async payload => {
    const request = {
      url: `${this.API_URL}/distributionlist/getemailaddressesbyfilter`,
      headers: this.getHeaders(),
      method: 'POST',
      data: payload
    };

    const response = await axios.request(request);

    return response.data;
  };

  /**
   * Get recipients excel file by distribution list filters
   * @param payload
   */
  getEmailAddressesExcelByFilter = async payload => {
    const request = {
      url: `${this.API_URL}/distributionlist/getemailaddressesbyfilter/excel`,
      headers: this.getHeaders(),
      method: 'POST',
      responseType: 'blob',
      data: payload
    };

    const response = await axios.request(request);

    return response.data;
  };

  /**
   * Get recipients excel file by distribution list id
   * @param id
   */
  async getRecipientsExcelForDistList(id) {
    const request = {
      url: `${this.API_URL}/distributionlist/recipients/excel?id=${id}`,
      headers: this.getHeaders(),
      responseType: 'blob',
      method: 'POST'
    };

    const response = await axios.request(request);

    return response.data;
  }

  /**
   * Get contacts you havenot added in distribution list while
   * creating distribution list
   * @param {*} payload
   */
  getExcludedContactsFromDistributionList = async payload => {
    const request = {
      url: `${this.API_URL}/distributionlist/recipients/notselected`,
      headers: this.getHeaders(),
      method: 'POST',
      data: payload
    };

    const response = await axios.request(request);

    return response.data;
  };

  /**
   * Send email to unsaved DL
   * @param {*} payload
   */
  async sendMail(payload) {
    const request = {
      url: `${this.API_URL}/distributionlist/mail`,
      method: 'POST',
      headers: this.getHeaders(),
      data: payload
    };

    const response = await axios.request(request);
    return response.data;
  }

  async validateImportFromExcel(payload) {
    const request = {
      url: `${this.API_URL}/distributionlist/validateimportfromexcel`,
      method: 'POST',
      headers: this.getHeaders(),
      data: payload
    };

    const response = await axios.request(request);
    return response.data;
  }

  async downloadDistributionListImportTemplate() {
    const request = {
      url: `${this.API_URL}/distributionlist/import/template`,
      method: 'GET',
      responseType: 'blob',
      headers: this.getHeaders()
    };

    const response = await axios.request(request);

    return response.data;
  }

  /**
   * Update of single distribution list
   * @param id
   * @param {*} payload
   */
  async updateDistributionList(id, payload) {
    const request = {
      url: `${this.API_URL}/distributionlist?id=${id}`,
      headers: this.getHeaders(),
      data: payload,
      method: 'PUT'
    };
    const response = await axios.request(request);
    return response.data;
  }
}

export default new DistributionListApi();
